import { ref } from 'vue';

export const axiosConnections = ref(0);
